<template>
<div class="chapter">
<div class="inner_page">
<div class="backMatterPage" id="bm02">
<div class="chapterHead">
<div class="chapterBody">
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords">To my extraordinary family</span>—Caitlin, the most beautiful wife a man can have, y mis chiquitos: Inés Celestia and Leopoldo Valerio (you grew up ten years in a week and I love you). To my mother, Andrea Valeria, whose voice is loved by all radio waves, including the astrophysical powers that emit them. To all my big familia—my dad, Leon Garcia, Gwendollyn, Christianne, Everardo, Joseph, Robert, Eloise, Roman, Tula, Magaly, Alexis, Guillermo, Jane, Solveig, Jim, James, Sophia, Christina, Norbushka, Hubbaba—everyone else in this world and the other.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3b6a9a5f